import Configs from "../config";
import { CreateCampaignStepIRoute } from "../generated/Api";
import { localStorageGetItem } from "../utils/LocalStorage";

async function getCampaignStepsFromContact(
  contactId: string
): Promise<CreateCampaignStepIRoute[] | false> {
  const token = localStorageGetItem("USER_TOKEN");
  const response: Response = await fetch(
    `${Configs.SERVER_URL}/campaignStep/contactId/${contactId}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  if (response.ok) {
    const responseObj = await response.json();
    return responseObj.data;
  } else {
    return false;
  }
}

export const CampaignStepAPI = {
  getCampaignStepsFromContact,
};
